'use strict';

var dataLayer = window.dataLayer || [];
var pageAction = $('.page-action').val();

module.exports = {
    addToCartEvent: function (productJSON, currency, quantity) {
        var obj = {
            event: 'add_to_cart',
            ecommerce: {
                currency: currency || 'N/A',
                value: quantity * productJSON.price,
                items: [
                    {
                        item_id: productJSON.item_id || 'N/A',
                        item_name: productJSON.item_name || 'N/A',
                        affiliation: productJSON.affiliation || 'N/A',
                        coupon: productJSON.coupon || 'N/A',
                        discount: productJSON.discount || 'N/A',
                        index: productJSON.index || 'N/A',
                        item_brand: productJSON.item_brand || 'N/A',
                        item_category1: productJSON.item_category1 || 'N/A',
                        item_category2: productJSON.item_category2 || 'N/A',
                        item_category3: productJSON.item_category3 || 'N/A',
                        item_category4: productJSON.item_category4 || 'N/A',
                        item_category5: productJSON.item_category5 || 'N/A',
                        item_list_id: productJSON.item_list_id || 'N/A',
                        item_list_name: productJSON.item_list_name || 'N/A',
                        item_variant: productJSON.item_variant || 'N/A',
                        item_variant1: productJSON.item_variant1 || 'N/A',
                        item_variant2: productJSON.item_variant2 || 'N/A',
                        item_variant3: productJSON.item_variant3 || 'N/A',
                        item_variant4: productJSON.item_variant4 || 'N/A',
                        item_variant5: productJSON.item_variant5 || 'N/A',
                        item_variant6: productJSON.item_variant6 || 'N/A',
                        item_variant7: productJSON.item_variant7 || 'N/A',
                        item_variant8: productJSON.item_variant8 || 'N/A',
                        location_id: productJSON.location_id || 'N/A',
                        price: productJSON.price || 'N/A',
                        quantity: quantity
                    }
                ]
            }
        };
        dataLayer.push(obj);
    },
    removeFromCartEvent: function (productJSON, currency, quantity) {
        var obj = {
            event: 'remove_from_cart',
            ecommerce: {
                currency: currency,
                value: quantity * productJSON.price,
                items: [
                    {
                        item_id: productJSON.item_id || 'N/A',
                        item_name: productJSON.item_name || 'N/A',
                        affiliation: productJSON.affiliation || 'N/A',
                        coupon: productJSON.coupon || 'N/A',
                        discount: productJSON.discount || 'N/A',
                        index: productJSON.index || 'N/A',
                        item_brand: productJSON.item_brand || 'N/A',
                        item_category: productJSON.item_category1 || 'N/A',
                        item_category2: productJSON.item_category2 || 'N/A',
                        item_category3: productJSON.item_category3 || 'N/A',
                        item_category4: productJSON.item_category4 || 'N/A',
                        item_category5: productJSON.item_category5 || 'N/A',
                        item_list_id: productJSON.item_list_id || 'N/A',
                        item_list_name: productJSON.item_list_name || 'N/A',
                        item_variant: productJSON.item_variant || 'N/A',
                        location_id: productJSON.location_id || 'N/A',
                        price: productJSON.price,
                        quantity: quantity
                    }
                ]
            }
        };

        dataLayer.push(obj);
    }
}

var events = {
    all: function () {

        $('.add-to-wish-list').on('click', function () {
            var $gtmData = $('.gtm-data');
            var productJSON = $gtmData.data('gtm');
            var productQuantity = $('.product-detail').find('.quantity-select').val();
            var quantity = productQuantity || 'N/A';
            var price = productJSON.price || 'N/A';
            var obj = {
                event: 'add_to_wishlist',
                ecommerce: {
                    currency: $gtmData.data('item-currency') || 'N/A',
                    value: quantity * price,
                    items: [
                        {
                            item_id: productJSON.item_id || 'N/A',
                            item_name: productJSON.item_name || 'N/A',
                            affiliation: productJSON.affiliation || 'N/A',
                            coupon: productJSON.coupon || 'N/A',
                            discount: productJSON.discount || 'N/A',
                            index: productJSON.index || 'N/A',
                            item_brand: productJSON.item_brand || 'N/A',
                            item_category: productJSON.item_category1 || 'N/A',
                            item_category2: productJSON.item_category2 || 'N/A',
                            item_category3: productJSON.item_category3 || 'N/A',
                            item_category4: productJSON.item_category4 || 'N/A',
                            item_category5: productJSON.item_category5 || 'N/A',
                            item_list_id: productJSON.item_list_id || 'N/A',
                            item_list_name: productJSON.item_list_name || 'N/A',
                            item_variant: productJSON.item_variant || 'N/A',
                            location_id: productJSON.location_id || 'N/A',
                            price: price,
                            quantity: quantity
                        }
                    ]
                }
            };
            dataLayer.push(obj);
        });
    }
};

/**
 * @function init
 * @description Initialize the tag manager functionality
 * @param {String} nameSpace The current name space
 */
$(document).ready(function () {
    if (window.gtmEnabled) {
        if (pageAction && events[pageAction]) {
            events[pageAction]();
        }
        events.all();
    }
});
